import ctl from '@netlify/classnames-template-literals';

const bodyRowStyle = ctl(`
  border-t-chinese-silver 
  border-t-[1px] 
  text-sm hover:bg-ghost-white 
  transition-colors
  cursor-pointer
`);

const cellStyle = ctl(`
  flex 
  items-center 
  gap-[6px] 
  offset-base
`);

const indicatorBaseStyle = ctl(`
  w-2 
  h-2
  rounded-[50%]
`);

const activeIndicatorStyles = ctl(`
  ${indicatorBaseStyle}
  bg-green-ncs
`);

const indicatorStyles = ctl(`
  ${indicatorBaseStyle}
  bg-american-pink
`);

export { bodyRowStyle, cellStyle, activeIndicatorStyles, indicatorStyles };
